import { Button, Text } from '@mantine/core';

const GreenButton = (model: any) => {
  return (
    <Button
      bg="#58C367"
      color="white"
      fw={500}
      size="sm"
      styles={{
        root: {
          ":hover": {
            background: "#4dae5a !important"
          },
          ":disabled": {
            background: "#4dae5a47 !important"
          }
        }
      }}
      {...model}
    >

      <Text color="white" display={'flex'}>
        {model.children}
      </Text>
    </Button>
  );
};

export default GreenButton